import { WorkflowManager } from '../core/workflow-manager';
import { logger } from './logger';

/**
 * 设置监视模式的通用函数
 */
export async function setupWatchMode(
  manager: WorkflowManager,
  actionName: string = 'task watcher'
): Promise<void> {
  logger.info(`Starting ${actionName}...`);
  
  try {
    await manager.startWatching();
    logger.success(`${actionName} is running. Press Ctrl+C to stop.`);
    
    // 设置优雅退出
    setupGracefulExit(manager, actionName);
    
    // 保持进程运行
    await keepProcessAlive();
  } catch (error: any) {
    logger.error(`Failed to start ${actionName}:`, error.message);
    throw error;
  }
}

/**
 * 设置优雅退出处理
 */
function setupGracefulExit(manager: WorkflowManager, actionName: string): void {
  const exitHandler = async () => {
    logger.info(`\nStopping ${actionName}...`);
    
    try {
      await manager.stopWatching();
      logger.success(`${actionName} stopped successfully.`);
      process.exit(0);
    } catch (error: any) {
      logger.error(`Error stopping ${actionName}:`, error.message);
      process.exit(1);
    }
  };
  
  // 处理各种退出信号
  process.on('SIGINT', exitHandler);
  process.on('SIGTERM', exitHandler);
  
  // Windows 平台特殊处理
  if (process.platform === 'win32') {
    const readline = require('readline');
    const rl = readline.createInterface({
      input: process.stdin,
      output: process.stdout
    });
    
    rl.on('SIGINT', () => {
      process.emit('SIGINT' as any);
    });
  }
}

/**
 * 保持进程活跃
 */
function keepProcessAlive(): Promise<never> {
  return new Promise(() => {
    // 进程将保持运行直到收到退出信号
  });
}